var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#EBFAF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4954 8.91797C17.705 8.91797 8.91211 17.7109 8.91211 28.5013C8.91211 39.2917 17.705 48.0846 28.4954 48.0846C39.2859 48.0846 48.0788 39.2917 48.0788 28.5013C48.0788 17.7109 39.2859 8.91797 28.4954 8.91797ZM37.8563 23.9971L26.7525 35.1009C26.4784 35.3751 26.1063 35.5317 25.7146 35.5317C25.3229 35.5317 24.9509 35.3751 24.6767 35.1009L19.1346 29.5588C18.5667 28.9909 18.5667 28.0509 19.1346 27.483C19.7025 26.9151 20.6425 26.9151 21.2104 27.483L25.7146 31.9871L35.7804 21.9213C36.3484 21.3534 37.2884 21.3534 37.8563 21.9213C38.4242 22.4892 38.4242 23.4096 37.8563 23.9971Z",
    fill: "#0CB95B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigSuccess);
export default __webpack_public_path__ + "static/media/big-success.60a4b12b.svg";
export { ForwardRef as ReactComponent };